import { Link } from 'react-router'
import { ChevronRight } from 'lucide-react'
import { useCategoryDetail } from './context'
import { useCategoryTransactions } from './use-category-transactions'

type Props = {
  href: string
}

export function CategoryTransactionsFooter({ href }: Props) {
  const { categoryName, filteredTransactions } = useCategoryDetail()
  const categoryTxs = useCategoryTransactions(filteredTransactions, categoryName)

  if (categoryTxs.length === 0) return null

  return (
    <div className="border-t pt-3">
      <Link
        to={href}
        className="flex items-center justify-center gap-1 text-sm text-primary hover:underline"
      >
        この月の{categoryName}の取引をすべて見る
        <ChevronRight className="size-4" />
      </Link>
    </div>
  )
}
